import DropdownReg from '../../components/dropdownReg/DropdownReg';

const BookingReadOnly = ({ bookingData, setBookingData }) => {
    const bookingTypes = ['Website', 'Manual'];
    const numPeople = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const vehicleModes = ['Self Bike', 'Self Car', 'Bike Rent', 'Car Rent', 'Pillion on bike', 'Co-passenger in car'];

    const comfortableOptions = ['Yes', 'No'];

    return (
        <>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Booking Id</label>
                <div className='dropRegInputDiv'>
                    <input
                        value={bookingData._id}
                        name='_id'
                        // onChange={(e) => handleChange(e, setBookingData)}
                        type='Text'
                        placeholder={`Booking Id`}
                        className='dropRegSelect'
                        disabled={true}
                    ></input>
                </div>
            </div>
            <DropdownReg
                label='Booking Type'
                name='bookedVia'
                options={bookingTypes}
                value={bookingData.bookedVia}
                req={true}
                setFormData={setBookingData}
                disabled={true}
            />
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Total Seats</label>
                <div className='dropRegInputDiv'>
                    <select
                        value={bookingData.totalSeats}
                        name='totalSeats'
                        // onChange={(e) => handleChange(e, setBookingData)}
                        required={true}
                        className='dropRegSelect'
                        disabled={true}
                    >
                        {numPeople.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            {bookingData?.vehicle && (
                <>
                    <DropdownReg
                        label='Select Vehicle'
                        name='mode'
                        options={vehicleModes}
                        value={bookingData?.vehicle.mode}
                        req={true}
                        setFormData={setBookingData}
                        nest='vehicle'
                        disabled={true}
                    />
                    {bookingData?.vehicle?.mode && (
                        <div className='vehicle-input-container'>
                            {['Self Bike', 'Self Car'].includes(bookingData?.vehicle.mode) && (
                                <div className='dropRegDiv'>
                                    <label htmlFor='vehicleModel' className='dropRegLabel'>
                                        Model
                                    </label>
                                    <div className='dropRegInputDiv'>
                                        <input
                                            id='vehicleModel'
                                            name='model'
                                            type='text'
                                            className='dropRegSelect'
                                            placeholder={
                                                bookingData?.vehicle.mode === 'Self Bike'
                                                    ? 'e.x. Royal Enfield Classic'
                                                    : 'e.x. Maruti Swift'
                                            }
                                            value={bookingData?.vehicle.model}
                                            disabled={true}
                                            // onChange={(e) => handleNestedChange(e, setBookingData, 'vehicle')}
                                        />
                                    </div>{' '}
                                </div>
                            )}
                            {bookingData?.vehicle.mode !== '-1' &&
                                bookingData?.vehicle.mode !== '' &&
                                !['Pillion on bike', 'Co-passenger in car'].includes(bookingData?.vehicle.mode) && (
                                    <>
                                        <DropdownReg
                                            label='Comfortable'
                                            name='comfortable'
                                            options={comfortableOptions}
                                            value={bookingData?.vehicle?.comfortable}
                                            req={true}
                                            setFormData={setBookingData}
                                            nest={'vehicle'}
                                            disabled={true}
                                        />
                                        {bookingData?.vehicle?.comfortable === 'Yes' && (
                                            <div className='dropRegDiv'>
                                                <label
                                                    style={{ marginTop: 10 }}
                                                    htmlFor='emptySeats'
                                                    className='dropRegLabel'
                                                >
                                                    Empty Seats
                                                </label>
                                                <div className='dropRegInputDiv'>
                                                    <input
                                                        id='emptySeats'
                                                        name='emptySeats'
                                                        type='number'
                                                        className='dropRegSelect'
                                                        placeholder='e.x. 2'
                                                        value={bookingData?.vehicle?.emptySeats}
                                                        min='0'
                                                        max='6'
                                                        disabled={true}
                                                        // onChange={(e) => {
                                                        //     handleNestedChange(e, setBookingData, 'vehicle');
                                                        // }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}{' '}
                        </div>
                    )}{' '}
                </>
            )}
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Is Reserved?</label>
                <div className='dropRegInputDiv radioDiv'>
                    <label>
                        <input
                            type='radio'
                            name='isReserved'
                            value='true'
                            checked={bookingData?.amountPaid?.isReserved === true}
                            // onChange={(e) =>
                            //     handleNestedChange(
                            //         {
                            //             target: {
                            //                 name: 'isReserved',
                            //                 value: e.target.value === 'true'
                            //             }
                            //         },
                            //         setBookingData,
                            //         'amountPaid'
                            //     )
                            // }
                            disabled={true}
                        />
                        Yes
                    </label>

                    <label>
                        <input
                            type='radio'
                            name='isReserved'
                            value='false'
                            checked={bookingData?.amountPaid?.isReserved === false}
                            // onChange={(e) =>
                            //     handleNestedChange(
                            //         {
                            //             target: {
                            //                 name: 'isReserved',
                            //                 value: e.target.value === 'true'
                            //             }
                            //         },
                            //         setBookingData,
                            //         'amountPaid'
                            //     )
                            // }
                            disabled={true}
                        />
                        No
                    </label>
                </div>
            </div>
            <div>
                {Array.apply(null, { length: bookingData.totalSeats }).map((_, peopleIndex) => (
                    <div key={peopleIndex} className='reviewBoInfoUserDiv'>
                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Name</label>

                                <input
                                    value={bookingData.userDetails[peopleIndex]?.name || ''}
                                    name='name'
                                    // onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder={`Person ${peopleIndex + 1} name`}
                                    className='reviewBoInfoInput'
                                    disabled={true}
                                />
                                {/* <CharCount
                                    string={bookingData.userDetails[peopleIndex]?.name || ''}
                                    min={3}
                                    limit={30}
                                /> */}
                            </div>

                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Age</label>

                                <input
                                    value={bookingData.userDetails[peopleIndex]?.age || ''}
                                    name='age'
                                    // onChange={(e) => handleUser(e, peopleIndex)}
                                    type='number'
                                    placeholder="Person's age"
                                    className='reviewBoInfoInput'
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Gender</label>

                                <select
                                    value={bookingData.userDetails[peopleIndex]?.sex || 'Select'}
                                    name='sex'
                                    // onChange={(e) => handleUser(e, peopleIndex)}
                                    className='reviewBoInfoInput'
                                    disabled={true}
                                >
                                    <option value='Select'>Select</option>
                                    <option value='Male'>Male</option>
                                    <option value='Female'>Female</option>
                                    <option value='Others'>Others</option>
                                </select>
                            </div>

                            {peopleIndex === 0 ? (
                                <div className='reviewBoInfoName'>
                                    <label className='reviewBoInfoLabel'>Email</label>

                                    <input
                                        value={bookingData.userDetails[peopleIndex]?.emailId || ''}
                                        name='emailId'
                                        // onChange={(e) => handleUser(e, peopleIndex)}
                                        type='text'
                                        placeholder={`Email Id of person ${peopleIndex + 1}`}
                                        className='reviewBoInfoInput'
                                        disabled={true}
                                    />
                                </div>
                            ) : (
                                <div className='reviewBoInfoName'>
                                    <label className='reviewBoInfoLabel'>Phone Number (WhatsApp)</label>

                                    <input
                                        value={bookingData.userDetails[peopleIndex]?.phoneNumber || ''}
                                        name='phoneNumber'
                                        type='tel'
                                        inputMode='numeric'
                                        placeholder='Mobile Number'
                                        className='reviewBoInfoInput'
                                        // onChange={(e) => {
                                        //     let value = e.target.value.replace(/\D/g, '');
                                        //     value = value.replace(/^0+/, '');

                                        //     if (value.length <= 10) {
                                        //         handleUser({ target: { name: 'phoneNumber', value } }, peopleIndex);
                                        //     }
                                        // }}
                                        disabled={true}
                                    />
                                </div>
                            )}
                        </div>

                        {peopleIndex === 0 && (
                            <div className='reviewBoInfoNameAge'>
                                <div className='reviewBoInfoName'>
                                    <label className='reviewBoInfoLabel'>Phone Number (WhatsApp)</label>

                                    <input
                                        value={bookingData.userDetails[peopleIndex]?.phoneNumber || ''}
                                        name='phoneNumber'
                                        type='tel'
                                        inputMode='numeric'
                                        placeholder='Mobile Number'
                                        className='reviewBoInfoInput'
                                        // onChange={(e) => {
                                        //     let value = e.target.value.replace(/\D/g, '');
                                        //     value = value.replace(/^0+/, '');

                                        //     if (value.length <= 10) {
                                        //         handleUser({ target: { name: 'phoneNumber', value } }, peopleIndex);
                                        //     }
                                        // }}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default BookingReadOnly;
